import { FETCH_MASJID, FETCH_MASJIDS } from "../../ActionType";
import { Action, Masjid } from "../../../../Types";

const FetchSingleMasjidReducer = (
  masjids: Masjid[] = [],
  action: Action
): Masjid[] => {
  switch (action.type) {
    case FETCH_MASJID:
      return action.payload;
    default:
      return masjids;
  }
};

export default FetchSingleMasjidReducer;
